import { faArrowRightArrowLeft } from "@jewlr/pro-thin-svg-icons/faArrowRightArrowLeft"
import { faRingsWedding } from "@jewlr/pro-thin-svg-icons/faRingsWedding"
import { faShieldCheck } from "@jewlr/pro-thin-svg-icons/faShieldCheck"
import { faTruckFast as thinTruckFast } from "@jewlr/pro-thin-svg-icons/faTruckFast"
import { faLeafMaple } from "@jewlr/sharp-light-svg-icons/faLeafMaple"
import PropTypes from "prop-types"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { jewlr_t, IS_NA, IS_GE_CHECKOUT } from "helpers/application"
import { cn } from "styles/utils"

const Br = () => <br className="desktop:hidden" />

const perks = () => {
  const is_ge_checkout = IS_GE_CHECKOUT()
  return [
    {
      description: `We offer fast, free standard ${jewlr_t(
        "terms.shipping"
      )} directly to your doorstep.`,
      icon: thinTruckFast,
      key: "free-shipping",
      text: (
        <>
          Free <Br />
          {jewlr_t("terms.Shipping")}
        </>
      ),
    },
    {
      description: `Buy with confidence! We offer a no-hassle ${is_ge_checkout ? "30" : "99"}-day return policy.`,
      icon: faArrowRightArrowLeft,
      key: "returns",
      text: (
        <>
          {is_ge_checkout ? "30" : "99"}-Day <Br />
          Returns
        </>
      ),
    },
    {
      description: `Our ${jewlr_t(
        "terms.jewelry"
      )} includes a free one-year manufacturer’s warranty.`,
      icon: faShieldCheck,
      key: "warranty",
      text: (
        <>
          One-Year <Br />
          Warranty
        </>
      ),
    },
    ...(IS_NA()
      ? [
          {
            description:
              "Get one ring resizing within 30 days of the original shipment date.",
            icon: faRingsWedding,
            key: "resizing",
            text: (
              <>
                Free Ring <Br />
                Resizing
              </>
            ),
          },
        ]
      : [
          {
            description: "Made-to-order in Canada using premium materials.",
            icon: faLeafMaple,
            key: "made-in-ca",
            text: (
              <>
                Made in <Br />
                Canada
              </>
            ),
          },
        ]),
  ]
}

const LandingPerks = ({ element }) => {
  const { data: { show_heading = true, show_white_icons } = {} } = element || {}
  const { className: blockClassName, ...blockProps } =
    element.style?.block_style || {}
  const { className: containerClassName, ...containerProps } =
    element.style?.container_style || {}

  return (
    <section
      aria-labelledby="perks-heading"
      className={cn(blockClassName)}
      {...blockProps}
    >
      <div
        className={cn(
          "desktop:flex-row desktop:gap-80 tablet:px-32 widescreen:px-60 desktop:py-60 flex flex-col items-center justify-between gap-24 px-16 py-32",
          element.contain && "contained-wide",
          containerClassName
        )}
        {...containerProps}
      >
        {show_heading ? (
          <h2
            className="text-24 desktop:text-48 widescreen:text-56 font-bold"
            id="perks-heading"
          >
            We&apos;ve Got <br className="desktop:block hidden" />
            Standards
          </h2>
        ) : (
          <h2 className="sr-only" id="perks-heading">
            Shopping Perks
          </h2>
        )}
        <ul className="grid w-full flex-1 list-none grid-cols-4 gap-8">
          {perks().map((perk) => (
            <li className="text-center" key={perk.key}>
              <FontAwesomeIcon
                className={cn(
                  "text-38 desktop:text-40 mb-20",
                  show_white_icons ? "text-white" : "text-black"
                )}
                icon={perk.icon}
                widthAuto
              />
              <p className="text-12 desktop:text-18 font-semibold uppercase">
                {perk.text}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

LandingPerks.propTypes = {
  element: PropTypes.object,
}

export default LandingPerks
